import React from 'react';
import ChatBlockTable from '@/components/ChatBlockTable';
import ChatBlockChart from '@/components/ChatBlockChart';

export default function ChatMessageBlocks({ blocks }) {
  if (!Array.isArray(blocks) || blocks.length === 0) return null;

  return (
    <div className="space-y-4 mb-3">
      {blocks.map((block) => {
        if (block?.type === 'table') {
          return <ChatBlockTable key={block.id} block={block} />;
        }
        if (block?.type === 'chart') {
          return <ChatBlockChart key={block.id} block={block} />;
        }
        return null;
      })}
    </div>
  );
}
